<template>
    <v-row>
      <v-col cols="12">
          <sale-category-per-day-card> </sale-category-per-day-card> 
      </v-col>
    </v-row>
  </template>
  <script>
  import SaleCategoryPerDayCard from "@/components/report/SaleCategoryPerDayCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Sales Category Per Day",
    },
  
    components: {
        SaleCategoryPerDayCard
    },
  
    data() {
      return {
      };
    },
  };
  </script>